import { SignalSuggestion } from '../types';

const STORAGE_KEY = 'skylarq_saved_signals';

export interface SavedSignal extends SignalSuggestion {
  savedAt: string;
  icpId: string;
  icpName: string;
}

// Get all saved signals
export function getAllSavedSignals(): SavedSignal[] {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
}

// Get saved signals for a specific ICP
export function getSavedSignalsForICP(icpId: string): SavedSignal[] {
  return getAllSavedSignals().filter(s => s.icpId === icpId);
}

// Save a signal
export function saveSignal(signal: SignalSuggestion, icpId: string, icpName: string): SavedSignal {
  const savedSignals = getAllSavedSignals();

  // Check if already saved (by name + icpId)
  const existingIndex = savedSignals.findIndex(
    s => s.name === signal.name && s.icpId === icpId
  );

  const savedSignal: SavedSignal = {
    ...signal,
    savedAt: new Date().toISOString(),
    icpId,
    icpName,
  };

  if (existingIndex >= 0) {
    // Update existing
    savedSignals[existingIndex] = savedSignal;
  } else {
    // Add new
    savedSignals.push(savedSignal);
  }

  localStorage.setItem(STORAGE_KEY, JSON.stringify(savedSignals));
  return savedSignal;
}

// Remove a saved signal
export function unsaveSignal(signalName: string, icpId: string): void {
  const savedSignals = getAllSavedSignals();
  const filtered = savedSignals.filter(
    s => !(s.name === signalName && s.icpId === icpId)
  );
  localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered));
}

// Check if a signal is saved
export function isSignalSaved(signalName: string, icpId: string): boolean {
  return getAllSavedSignals().some(
    s => s.name === signalName && s.icpId === icpId
  );
}

// Toggle save state
export function toggleSaveSignal(
  signal: SignalSuggestion,
  icpId: string,
  icpName: string
): boolean {
  if (isSignalSaved(signal.name, icpId)) {
    unsaveSignal(signal.name, icpId);
    return false;
  } else {
    saveSignal(signal, icpId, icpName);
    return true;
  }
}
